import React from 'react';
import { motion } from 'framer-motion';
import { useMotionMode } from '../../contexts/MotionContext';

const EASE = [0.16, 1, 0.3, 1];

const VARIANTS = {
  premium: {
    hidden: { opacity: 0, y: 28 },
    visible: { opacity: 1, y: 0 },
  },
  cinematic: {
    hidden: { opacity: 0, y: 90, scale: 0.94, clipPath: 'inset(18% 0% 18% 0%)' },
    visible: { opacity: 1, y: 0, scale: 1, clipPath: 'inset(0% 0% 0% 0%)' },
  },
};

export const Reveal = ({ children, delay = 0, className = '', as = 'div', amount = 0.2, ...rest }) => {
  const { cinematic } = useMotionMode();
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount }}
      variants={cinematic ? VARIANTS.cinematic : VARIANTS.premium}
      transition={{ duration: cinematic ? 1.15 : 0.7, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export const RevealText = ({ text, className = '', delay = 0, animateOnMount = false }) => {
  const { cinematic } = useMotionMode();
  const trigger = animateOnMount
    ? { initial: 'hidden', animate: 'visible' }
    : { initial: 'hidden', whileInView: 'visible', viewport: { once: true, amount: 0.5 } };

  if (!cinematic) {
    return (
      <motion.span
        className={`inline-block ${className}`}
        variants={VARIANTS.premium}
        transition={{ duration: 0.8, ease: EASE, delay }}
        {...trigger}
      >
        {text}
      </motion.span>
    );
  }

  return (
    <motion.span
      className={`inline-block ${className}`}
      transition={{ staggerChildren: 0.06, delayChildren: delay }}
      {...trigger}
    >
      {text.split(' ').map((word, i) => (
        <span key={`${word}-${i}`} className="inline-block overflow-hidden align-bottom pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="inline-block"
            variants={{ hidden: { y: '110%', rotate: 6 }, visible: { y: '0%', rotate: 0 } }}
            transition={{ duration: 1, ease: EASE }}
          >
            {word}
          </motion.span>
          {'\u00A0'}
        </span>
      ))}
    </motion.span>
  );
};
